export default __webpack_public_path__ + "879128a.png";